// extracted by mini-css-extract-plugin
export default {"container":"container___z7duO","title":"title___eizsE","content":"content___vbLas","amount":"amount___Lmt0e","symbol":"symbol___tbRWy","input":"input___JUsDg","tips":"tips___vpFcn"};